import React, { useContext, useEffect, useMemo, useState } from 'react';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import isString from 'lodash/isString';
import isFunction from 'lodash/isFunction';
import isPromise from 'is-promise';
import { ButtonColor } from '../button/enum';
import Button from '../button';
import { $l } from '../locale-context';
const templateStyle = { marginLeft: 0 };
const TemplateDownloadButton = function TempalteDownloadButton(props) {
    const { attachmentUUID, bucketName, bucketDirectory, storageCode, isPublic, target, funcType, color = ButtonColor.primary } = props;
    const { getConfig } = useContext(ConfigContext);
    const { getTemplateDownloadUrl } = getConfig('attachment');
    const downloadUrl = useMemo(() => getTemplateDownloadUrl ? getTemplateDownloadUrl({
        attachmentUUID,
        bucketName,
        bucketDirectory,
        storageCode,
        isPublic,
    }) : attachmentUUID, [
        getTemplateDownloadUrl, attachmentUUID, bucketName, bucketDirectory, storageCode, isPublic,
    ]);
    const [templateDownloadUrl, setTemplateDownloadUrl] = useState(() => downloadUrl);
    useEffect(() => {
        if (isPromise(downloadUrl)) {
            downloadUrl.then(url => setTemplateDownloadUrl(() => url));
        }
        else {
            setTemplateDownloadUrl(() => downloadUrl);
        }
    }, [downloadUrl]);
    if (templateDownloadUrl === undefined || isPromise(templateDownloadUrl)) {
        return null;
    }
    const downProps = {
        funcType,
        href: isString(templateDownloadUrl) ? templateDownloadUrl : undefined,
        onClick: isFunction(templateDownloadUrl) ? templateDownloadUrl : undefined,
        target,
        color,
        style: templateStyle,
    };
    return (React.createElement(Button, Object.assign({}, downProps),
        "(",
        $l('Attachment', 'download_template'),
        ")"));
};
TemplateDownloadButton.displayName = 'TemplateDownloadButton';
export default TemplateDownloadButton;
